'use client';

import React, { HTMLAttributes } from 'react';

type Props = {} & HTMLAttributes<HTMLButtonElement>;

const Hamburger = React.forwardRef<HTMLButtonElement, Props>((props, ref) => (
  <button
    className='hamburger'
    aria-expanded='false'
    ref={ref}
    {...props}
    onClick={e => {
      if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
        e.currentTarget.setAttribute('aria-expanded', 'true');
      } else {
        e.currentTarget.setAttribute('aria-expanded', 'false');
      }
    }}
  >
    <span />
  </button>
));

Hamburger.displayName = 'Hamburger';

export default Hamburger;
